import { error } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

const ManualAdvancePayment = gql`
  mutation MutationManualAdvancePayment(
    $idempotencyId: IdempotencyToken!
    $input: SubmitManualAdvancePaymentInput!
  ) {
    submitManualAdvancePayment(idempotencyId: $idempotencyId, input: $input) {
      ... on SubmitManualAdvancePaymentSuccess {
        code
        message
        infoMessage
        heroText
        title
        __typename
      }

      ... on SubmitManualAdvancePaymentError {
        __typename
        action {
          __typename
          id
          buttonText
          buttonStyle
          buttonOnClick {
            __typename
            ... on RouteNavigationAction {
              __typename
              route
            }
          }
        }
        ...error
      }
    }
  }
  ${error}
`;

export default ManualAdvancePayment;
